
import { defineComponent } from "vue";
import Sources from "@/data/sources";
import Metric from "@/types/metric";
export default defineComponent({
  setup() {
    const handleToggleEvent = (ev: CustomEvent) => {
      console.log("toggled");
      console.log(ev.detail);
    };

    return {
      handleToggleEvent,
    };
  },
  mounted() {
    this.$nextTick(function () {
      console.log(navigator.userAgent)
      const isiPhone = /iPhone/.test(navigator.userAgent);
      if(isiPhone) {
        document.body.className += " iPhone";
      }
    })

  },
  methods: {
    toggle: function (ref: any) {
      const newStatus = !(ref.getAttribute("aria-expanded") == "true");

      // Close all other open lists
      for (let [key, value] of Object.entries(this.$refs)) {
        let x = value as any;
        if (x !== ref) {
          let isExpanded = x.getAttribute("aria-expanded") == "true";
          if (key != "header" && isExpanded) {
            x.setAttribute("aria-expanded", "false");
            x.toggle();
          }

          // Set flags as closed
          if (key != "header") {
            this.accordStats[key] = false;
          }
        } else {
          // Set the flag for the clicked item
          this.accordStats[key] = newStatus;
        }
      }

      // Open or close clicked list
      const expanded = newStatus ? "true" : "false";
      ref.setAttribute("aria-expanded", expanded);
      ref.toggle();
    },
  },
  data() {
    return {
      laborForce: Sources.filter((x: Metric) => x.category == "laborForce"),
      unemployment: Sources.filter((x: Metric) => x.category == "unemployment"),
      industryJobs: Sources.filter((x: Metric) => x.category == "industryJobs"),
      economy: Sources.filter((x: Metric) => x.category == "economy"),
      population: Sources.filter((x: Metric) => x.category == "population"),
      accordStats: {
        laborForceMenu: false,
        unemploymentMenu: false,
        industryJobsMenu: false,
        economyMenu: false,
        populationMenu: false,
      } as any,
      baseURL: process.env.BASE_URL,
    };
  },
});
